@if (linesArray().length > 0) {
  @for (line of linesArray(); track line) {
    <p [class.animated]="!!animated()" class="{{animated() ? animated() : ''}} fake text variant-{{variant()}} color-{{color()}}"
      [style.width]="computedWidth(line)">&#8203;</p>
  }
} @else {
  <p class="text-adjustment variant-{{variant()}}">
  <span [class.animated]="!!animated()"
    class="{{animated() ? animated() : ''}} real text variant-{{variant()}} color-{{color()}}"><ng-content></ng-content></span>
  </p>
}
